import { Link as RouterLink } from 'react-router-dom';

import StatusChip from '@sayyesschool/frontend/components/status-chip';
import { LessonStatusLabel } from '@sayyesschool/frontend/features/lessons';
import { IconButton, Link, Table } from '@sayyesschool/frontend/ui-components';

const columns = [
    {
        key: 'learner',
        content: 'Ученик'
    },
    {
        key: 'teacher',
        content: 'Преподаватель'
    },
    {
        key: 'datetime',
        content: 'Дата и время'
    },
    {
        key: 'room',
        content: 'Аудитория'
    },
    {
        key: 'status',
        content: 'Статус'
    },
    {
        key: 'trial',
        content: 'Пробный'
    },
    {
        key: 'free',
        content: 'Бесплатный'
    },
    {
        key: 'actions'
    }
];

export default function LessonsTable({ lessons, onEdit, onDelete }) {
    return (
        <Table className="LessonsTable">
            <Table.Head>
                <Table.Row header>
                    {columns.map(col =>
                        <Table.Cell
                            {...col}
                            key={col.key}
                            header
                        />
                    )}
                </Table.Row>
            </Table.Head>

            <Table.Body>
                {lessons.map(lesson =>
                    <Table.Row key={lesson.id}>
                        <Table.Cell>
                            {lesson.learner ?
                                <Link
                                    as={RouterLink}
                                    to={`/learners/${lesson.learner.id}`}
                                    content={lesson.learner.fullname}
                                    color="neutral"
                                    variant="plain"
                                    underline="none"
                                />
                                :
                                '–'
                            }
                        </Table.Cell>

                        <Table.Cell>
                            {lesson.teacher &&
                                <Link
                                    as={RouterLink}
                                    to={`/teachers/${lesson.teacher.id}`}
                                    content={lesson.teacher.fullname}
                                    color="neutral"
                                    variant="plain"
                                    underline="none"
                                />
                            }
                        </Table.Cell>

                        <Table.Cell>
                            {lesson.dateStringAbs} · {lesson.timeStringAbs}
                        </Table.Cell>

                        <Table.Cell>
                            {lesson.room?.name}
                        </Table.Cell>

                        <Table.Cell>
                            <StatusChip
                                status={lesson.status}
                                content={LessonStatusLabel[lesson.status]}
                            />
                        </Table.Cell>

                        <Table.Cell content={lesson.trial ? 'Да' : 'Нет'} />
                        <Table.Cell content={lesson.free ? 'Да' : 'Нет'} />

                        <Table.Cell align="end">
                            <IconButton.Group
                                buttons={[
                                    {
                                        key: 'edit',
                                        title: 'Изменить',
                                        icon: 'edit',
                                        onClick: () => onEdit(lesson)
                                    },
                                    {
                                        key: 'delete',
                                        title: 'Удалить',
                                        icon: 'delete',
                                        color: 'danger',
                                        onClick: () => onDelete(lesson)
                                    }
                                ]}
                                size="sm"
                                color="neutral"
                                variant="plain"
                                align="end"
                            />
                        </Table.Cell>
                    </Table.Row>
                )}
            </Table.Body>
        </Table>
    );
}